import React, { Component } from "react";
import Chart from "react-google-charts";
import { Query } from "react-apollo";
import { Box, Grid, Text } from "grommet";
const gql = require("apollo-boost").gql;

const GET_ROLE_INSTANCE = gql`
  query MyQuery($Id: uuid) {
    RoleInstance(where: { Id: { _eq: $Id } }) {
      DateTimeEnd
      timeStart
    }
  }
`;

const UPDATE_END_TIME = gql`
  mutation MyMutation($id: uuid, $DateTimeEnd: timestamptz) {
    insert_RoleInstance(
      objects: { DateTimeEnd: $DateTimeEnd, Id: $id }
      on_conflict: {
        constraint: RoamRoleInstance_pkey
        update_columns: DateTimeEnd
      }
    ) {
      affected_rows
    }
  }
`;

const GET_LAST_LOCATION = gql`
  query MyQuery($id: uuid) {
    IoLocLocation(
      order_by: { DateTime: desc }
      where: { RoleInstanceId: { _eq: $id } }
      limit: 1
    ) {
      Latitude
      Longitude
      DateTime
    }
  }
`;

const GET_ROLE_INSTANCES = gql`
  query MyQuery(
    $id: bigint!
    $exclId: bigint
    $exclId2: bigint
    $exclId3: uuid
    $exclId4: uuid
  ) {
    Shift(where: { Id: { _eq: $id } }) {
      Description
      EndDateTime
      Id
      StartDateTime
      buildingId
      Shift_Gaurds(
        where: {
          GaurdId: { _neq: $exclId }
          _and: { GaurdId: { _neq: $exclId2 } }
        }
      ) {
        Breaks {
          EndDateTime
          Id
          POIId
          ShiftGaurdId
          StartDateTime
          Type
        }
        DeviceID
        Id
        Incidents {
          Description
          EndDateTime
          Id
          ImageUrl
          Lat
          Long
          ShiftGaurdId
          StartDateTime
          Title
        }
        RoleInstances(
          where: { Id: { _neq: $exclId3 }, _and: { Id: { _neq: $exclId4 } } }
          order_by: { timeStart: asc }
        ) {
          DateTimeEnd
          timeStart
          Id
          PatrolPointsReached
          RoleId
          Role {
            Id
            Lat
            Lng
            Title
            Type
            ColourCode
          }
        }
        TaskInstances {
          EndDateTime
          Id
          StartDateTime
          Task {
            Name
            IdealCompletionTime
          }
          completed
        }
        TotalDistanceWalked
        Gaurd {
          GaurdFirstName
          Id
          Url
        }
      }
    }
  }
`;

export class TimeLineView extends Component {
  pushData = [];

  componentDidMount = () => {};

  HSLToHex = (hslString) => {
    //hsl(120,100%,50%)
    const splitBracketArray = hslString.split("(");
    const valuesArray = splitBracketArray[1].split(",");
    const h = valuesArray[0];
    const sArray = valuesArray[1].split("%");
    const lArray = valuesArray[2].split("%");
    let l = lArray[0];
    let s = sArray[0];
    s /= 100;
    l /= 100;

    let c = (1 - Math.abs(2 * l - 1)) * s,
      x = c * (1 - Math.abs(((h / 60) % 2) - 1)),
      m = l - c / 2,
      r = 0,
      g = 0,
      b = 0;

    if (0 <= h && h < 60) {
      r = c;
      g = x;
      b = 0;
    } else if (60 <= h && h < 120) {
      r = x;
      g = c;
      b = 0;
    } else if (120 <= h && h < 180) {
      r = 0;
      g = c;
      b = x;
    } else if (180 <= h && h < 240) {
      r = 0;
      g = x;
      b = c;
    } else if (240 <= h && h < 300) {
      r = x;
      g = 0;
      b = c;
    } else if (300 <= h && h < 360) {
      r = c;
      g = 0;
      b = x;
    }
    // Having obtained RGB, convert channels to hex
    r = Math.round((r + m) * 255).toString(16);
    g = Math.round((g + m) * 255).toString(16);
    b = Math.round((b + m) * 255).toString(16);

    // Prepend 0s, if necessary
    if (r.length == 1) r = "0" + r;
    if (g.length == 1) g = "0" + g;
    if (b.length == 1) b = "0" + b;

    return "#" + r + g + b;
  };

  render() {
    let keyArray = [];
    let keyNameArray = [];
    const chartHeightValue = this.props.shiftGuardLength * 80;
    console.log(
      "Output: : TimeLineView -> render -> chartHeightValue",
      chartHeightValue
    );

    const chartHeight = "" + chartHeightValue + "px";

    {
      this.props.shiftGuards.map((shiftGuard, index) => {
        return shiftGuard.RoleInstances.map((roleInstance, index) => {
          if (!keyNameArray.includes(roleInstance.Role.Title)) {
            keyNameArray.push(roleInstance.Role.Title);
            keyArray.push({
              title: roleInstance.Role.Title,
              colour: roleInstance.Role.ColourCode,
              type: roleInstance.Role.Type,
            });
          }
        });
      });

      keyArray.push({
        title: "Break",
        colour: "hsl(300,100%,50%)",
        //type: roleInstance.Role.Type
      });

      keyArray.push({
        title: "Task",
        colour: "hsl(240,100%,50%)",
        //type: roleInstance.Role.Type
      });

      keyArray.push({
        title: "Incident",
        colour: "hsl(180,100%,50%)",
        //type: roleInstance.Role.Type
      });
    }
    return (
      <Box
        direction="column"
        border={{ color: "black", size: "small" }}
        alignContent="center"
        pad={{ top: "large", bottom: "large", horizontal: "medium" }}
      >
        <Box alignContent="center">
          <Grid
            alignContent="center"
            gap="small"
            columns={["small", "small", "small"]}
            align="center"
            justifyContent="center"
          >
            {keyArray.map((item, index) => {
              return (
                <Box
                  height="50px"
                  justify="center"
                  alignContent="center"
                  background={item.colour}
                  round="xxsmall"
                >
                  <Text textAlign="center">{item.title} </Text>
                  <Text textAlign="center">{item.type} </Text>
                </Box>
              );
            })}
          </Grid>
        </Box>
        <Box height="50px" ></Box>
        <Chart
          width={"device-width"}
          height={chartHeight}
          chartType="Timeline"
          loader={<div>Loading Chart</div>}
          data={this.props.pushData}
          options={{
            timeline: { showRowLabels: true },
            avoidOverlappingGridLines: true,
          }}
          rootProps={{ "data-testid": "1" }}
        />
      </Box>
    );
  }
}

const TimeLineQuery = (props) => {
  console.log(props);
  const variables = {
    id: props.shiftId,
    exclId: 1,
    exclId2: 2,
    exclId3: "e488a5a3-9d5e-4e7e-9557-f793bd4cc857",
    exclId4: "0703cd27-1a7a-4532-946e-0d9fa450047e",
  };

  const HSLToHex = (hslString) => {
    //hsl(120,100%,50%)
    const splitBracketArray = hslString.split("(");
    const valuesArray = splitBracketArray[1].split(",");
    const h = valuesArray[0];
    const sArray = valuesArray[1].split("%");
    const lArray = valuesArray[2].split("%");
    let l = lArray[0];
    let s = sArray[0];
    s /= 100;
    l /= 100;

    let c = (1 - Math.abs(2 * l - 1)) * s,
      x = c * (1 - Math.abs(((h / 60) % 2) - 1)),
      m = l - c / 2,
      r = 0,
      g = 0,
      b = 0;

    if (0 <= h && h < 60) {
      r = c;
      g = x;
      b = 0;
    } else if (60 <= h && h < 120) {
      r = x;
      g = c;
      b = 0;
    } else if (120 <= h && h < 180) {
      r = 0;
      g = c;
      b = x;
    } else if (180 <= h && h < 240) {
      r = 0;
      g = x;
      b = c;
    } else if (240 <= h && h < 300) {
      r = x;
      g = 0;
      b = c;
    } else if (300 <= h && h < 360) {
      r = c;
      g = 0;
      b = x;
    }
    // Having obtained RGB, convert channels to hex
    r = Math.round((r + m) * 255).toString(16);
    g = Math.round((g + m) * 255).toString(16);
    b = Math.round((b + m) * 255).toString(16);

    // Prepend 0s, if necessary
    if (r.length == 1) r = "0" + r;
    if (g.length == 1) g = "0" + g;
    if (b.length == 1) b = "0" + b;

    return "#" + r + g + b;
  };
  return (
    <Query query={GET_ROLE_INSTANCES} variables={variables}>
      {({ loading, error, data, client }) => {
        if (loading) {
          return <div>loading...</div>;
        }
        if (error) {
          console.log("timeline query error: ", error);
          return <div>Error</div>;
        }

        const shiftData = data.Shift[0];
        console.log("Output: : shiftData", shiftData);
        let pushData = [];
        const shiftGuards = shiftData.Shift_Gaurds;

        pushData.push([
          { type: "string", id: "Room" },
          { type: "string", id: "Name" },
          { type: "string", role: "style" },
          { type: "date", id: "Start" },
          { type: "date", id: "End" },
        ]);

        let timezone = 0;
        /*
        if (props.runningLocally) {
          timezone = -2;
        }*/
        for (const shiftGuard of shiftGuards) {
          const roleInstances = shiftGuard.RoleInstances;
          let index = 0;
          if (typeof roleInstances == "object") {
            for (const roleInstance of roleInstances) {
              let newRoleInstance = roleInstance;
              if (roleInstance.timeStart == roleInstance.DateTimeEnd) {
                console.log("times were equal", roleInstance);
                client
                  .query({
                    query: GET_LAST_LOCATION,
                    variables: {
                      id: roleInstance.Id,
                    },
                  })
                  .then((res) => {
                    console.log(res);
                    if (
                      typeof res.data.IoLocLocation === "object" &&
                      res.data.IoLocLocation.length !== 0
                    ) {
                      client.mutate({
                        mutation: UPDATE_END_TIME,
                        variables: {
                          id: roleInstance.Id,
                          DateTimeEnd: res.data.IoLocLocation[0].DateTime,
                        },
                      });
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }

              if (index !== 0) {
                const previousRoleInstance = roleInstances[index - 1];
                const currentStart = new Date(newRoleInstance.timeStart);
                //console.log("start = ", roleInstance.timeStart);
                const previousEnd = new Date(previousRoleInstance.DateTimeEnd);
                //console.log("end = ", previousRoleInstance.DateTimeEnd);
                if (
                  previousEnd > currentStart &&
                  roleInstance.timeStart !== roleInstance.DateTimeEnd
                ) {
                  //an error has occured and the end time must be adjusted

                  //delete the last element of pushdata
                  const oldEndTime = pushData.pop();
                  //TODO: create a log of this
                  console.log(
                    "Output: : TimeLineQuery -> oldEndTime",
                    oldEndTime
                  );

                  //update it and push it again
                  const role = previousRoleInstance.Role;
                  let rowArray = [];

                  if (role.Type === "Patrol") {
                    rowArray.push(shiftGuard.Gaurd.GaurdFirstName);
                    rowArray.push("");
                    rowArray.push(
                      HSLToHex(previousRoleInstance.Role.ColourCode)
                    );
                    /*
                const colorHex = HSLToHex("hsl(120,100%,50%)");
                console.log("Output: : colorHex", colorHex);
                rowArray.push(colorHex);*/
                    let start = new Date(previousRoleInstance.timeStart);
                    start.setHours(start.getHours() + timezone);
                    let end = new Date(newRoleInstance.timeStart);
                    end.setHours(end.getHours() + timezone);
                    if (start < end) {
                      rowArray.push(start);
                      rowArray.push(end);
                      pushData.push(rowArray);
                    } else {
                    }
                  } else if (role.Type === "Roam") {
                    rowArray.push(shiftGuard.Gaurd.GaurdFirstName);
                    rowArray.push("");
                    rowArray.push(
                      HSLToHex(previousRoleInstance.Role.ColourCode)
                    );

                    let start = new Date(previousRoleInstance.timeStart);
                    start.setHours(start.getHours() + timezone);
                    let end = new Date(newRoleInstance.timeStart);
                    end.setHours(end.getHours() + timezone);
                    if (start < end) {
                      rowArray.push(start);
                      rowArray.push(end);
                      pushData.push(rowArray);
                    }
                  } else if (role.Type === "Station") {
                    rowArray.push(shiftGuard.Gaurd.GaurdFirstName);
                    rowArray.push("");
                    rowArray.push(
                      HSLToHex(previousRoleInstance.Role.ColourCode)
                    );

                    let start = new Date(previousRoleInstance.timeStart);
                    start.setHours(start.getHours() + timezone);
                    let end = new Date(newRoleInstance.timeStart);
                    end.setHours(end.getHours() + timezone);
                    if (start < end) {
                      rowArray.push(start);
                      rowArray.push(end);
                      pushData.push(rowArray);
                    }
                  }
                }
              }
              const role = roleInstance.Role;
              let rowArray = [];

              if (role.Type === "Patrol") {
                rowArray.push(shiftGuard.Gaurd.GaurdFirstName);
                rowArray.push("");
                rowArray.push(HSLToHex(newRoleInstance.Role.ColourCode));
                /*
                const colorHex = HSLToHex("hsl(120,100%,50%)");
                console.log("Output: : colorHex", colorHex);
                rowArray.push(colorHex);*/
                let start = new Date(newRoleInstance.timeStart);
                start.setHours(start.getHours() + timezone);
                let end = new Date(newRoleInstance.DateTimeEnd);
                end.setHours(end.getHours() + timezone);
                if (start < end) {
                  rowArray.push(start);
                  rowArray.push(end);
                  pushData.push(rowArray);
                } else {
                }
              } else if (role.Type === "Roam") {
                rowArray.push(shiftGuard.Gaurd.GaurdFirstName);
                rowArray.push("");
                rowArray.push(HSLToHex(newRoleInstance.Role.ColourCode));

                let start = new Date(newRoleInstance.timeStart);
                start.setHours(start.getHours() + timezone);
                let end = new Date(newRoleInstance.DateTimeEnd);
                end.setHours(end.getHours() + timezone);
                if (start < end) {
                  rowArray.push(start);
                  rowArray.push(end);
                  pushData.push(rowArray);
                }
              } else if (role.Type === "Station") {
                rowArray.push(shiftGuard.Gaurd.GaurdFirstName);
                rowArray.push("");
                rowArray.push(HSLToHex(newRoleInstance.Role.ColourCode));

                let start = new Date(newRoleInstance.timeStart);
                start.setHours(start.getHours() + timezone);
                let end = new Date(newRoleInstance.DateTimeEnd);
                end.setHours(end.getHours() + timezone);
                if (start < end) {
                  rowArray.push(start);
                  rowArray.push(end);
                  pushData.push(rowArray);
                }
              }

              index++;
            }
          }

          const taskInstances = shiftGuard.TaskInstances;
          if (typeof taskInstances === "object" && taskInstances.length !== 0) {
            taskInstances.forEach((taskInstance) => {
              let rowArray = [];
              rowArray.push(shiftGuard.Gaurd.GaurdFirstName);
              rowArray.push("");
              rowArray.push(HSLToHex("hsl(240,100%,50%)"));
              let start = new Date(taskInstance.StartDateTime);
              start.setHours(start.getHours() + timezone);
              let end = new Date(taskInstance.EndDateTime);
              end.setHours(end.getHours() + timezone);
              if (start < end) {
                rowArray.push(start);
                rowArray.push(end);
                pushData.push(rowArray);
              }
            });
          }
          const breaks = shiftGuard.Breaks;
          if (typeof breaks === "object" && breaks.length !== 0) {
            breaks.forEach((taskInstance) => {
              let rowArray = [];
              rowArray.push(shiftGuard.Gaurd.GaurdFirstName);
              rowArray.push("");
              rowArray.push(HSLToHex("hsl(300,100%,50%)"));
              let start = new Date(taskInstance.StartDateTime);
              start.setHours(start.getHours() + timezone);
              let end = new Date(taskInstance.EndDateTime);
              end.setHours(end.getHours() + timezone);
              if (start < end) {
                rowArray.push(start);
                rowArray.push(end);
                pushData.push(rowArray);
              }
            });
          }
          const incidents = shiftGuard.Incidents;
          if (typeof incidents === "object" && incidents.length !== 0) {
            incidents.forEach((taskInstance) => {
              let rowArray = [];
              rowArray.push(shiftGuard.Gaurd.GaurdFirstName);
              rowArray.push("");
              rowArray.push(HSLToHex("hsl(180,100%,50%)"));
              let start = new Date(taskInstance.StartDateTime);
              start.setHours(start.getHours() + timezone);
              let end = new Date(taskInstance.EndDateTime);
              end.setHours(end.getHours() + timezone);
              if (start < end) {
                rowArray.push(start);
                rowArray.push(end);
                pushData.push(rowArray);
              }
            });
          }
        }

        return (
          <TimeLineView
            client={client}
            runningLocally={props.runningLocally}
            shiftGuardLength={shiftGuards.length}
            pushData={pushData}
            shiftGuards={shiftGuards}
          ></TimeLineView>
        );
      }}
    </Query>
  );
};

export default TimeLineQuery;
